import {Injectable} from '@angular/core';
//import {DataService} from "../../services/external-api/data.service";
import {Observable, of} from "rxjs";
import {ViewMode} from "@retail-data-factory/rdf-angular-types-api";
import {Presenter} from "../../../internal/presenter/presenter";
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class ApiPriceListService {

  constructor(public presenter: Presenter) {
  }

  viewMode: ViewMode;
}
